import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

export const styles = StyleSheet.create({
    container: {},
    textContainer: {
        paddingBottom: Device.isTablet ? 15 : null,
        paddingTop: Device.isTablet ? 15 : null,
        flexDirection: 'row',
        alignItems: 'center'
    },
    text: {
        color: Theme.primaryTextColor,
        letterSpacing: 1,
        fontSize: Theme.primaryFontSize,
        fontFamily: Theme.regularFont
    },
    channelName: {
        marginTop: 4,
        color: Theme.secondaryTextColor,
        fontSize: Theme.primaryFontSize,
        fontFamily: Theme.regularFont
    },
    iconContainer: {
        position: 'absolute',
        right: 0,
        top: Device.isTablet ? null : 0,
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    icon: {
        width: 20,
        height: 20
    },
    itemDivider: {
        marginVertical: Device.isTablet ? null : 15,
        backgroundColor: Theme.secondaryTextColor,
        opacity: 1,
        height: 1
    }
});
